import { useState, useRef, useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import { track } from "@/lib/util";
import { Truck, RefreshCw, Clock, Gem } from "lucide-react";

const Orn = ({ children }) => <div className="pd-orn"><span /><i>{children}</i><span /></div>;

export const Tabs = ({ tabs }) => {
  const [t, setT] = useState(0), [bar, setBar] = useState({ l: 0, w: 0 }), refs = useRef([]);
  const list = tabs.filter((x) => x.body);
  useLayoutEffect(() => { const el = refs.current[t]; if (el) setBar({ l: el.offsetLeft, w: el.offsetWidth }); }, [t, list.length]);
  if (!list.length) return null;
  return (
    <section className="pd mt-16 sm:mt-24" data-testid="product-tabs">
      <Orn>Le bijou en détail</Orn>
      <div className="pd-tabs" role="tablist"><div className="pd-tabs-in">
        {list.map((x, i) => <button key={x.label} ref={(e) => (refs.current[i] = e)} role="tab" aria-selected={t === i} onClick={() => { setT(i); track("product_tab_view", { tab: x.label }, { tab_name: x.label }); if (x.label === "Guide des tailles") track("size_guide_open", {}, { content_type: "product" }); }} data-testid={`tab-${x.label}`} className={t === i ? "is-on" : ""}>{x.label}</button>)}
        <span className="pd-bar" style={{ left: bar.l, width: bar.w }} />
      </div></div>
      <div className="pd-panel fade-up" key={t} data-testid="product-tab-panel">{list[t]?.body}</div>
    </section>
  );
};

export const Specs = ({ items }) => items.length ? (
  <dl className="pd-specs">{items.map(([k, v]) => <div key={k} data-testid={`spec-${k}`}><dt>{k}</dt><dd>{v}</dd></div>)}</dl>
) : null;

export const ShipCols = ({ thr, days, delay }) => (
  <div className="pd-ship">
    {[[Truck, "Livraison", `Offerte dès ${thr} € d'achat. Colis suivi, préparé avec soin.`, "/livraison", "Voir la livraison"],
      [Clock, "Délais", `Livré en ${delay}.`, "/delais", "Voir les délais"],
      [RefreshCw, "Retours", `Retours sous ${days} jours pour choisir sereinement.`, "/retours", "Voir les retours"]].map(([I, h, d, to, l]) => (
      <div key={h}><I size={22} strokeWidth={1.2} /><p className="pd-ship-h">{h}</p><p>{d}</p><Link to={to}>{l}</Link></div>))}
  </div>
);

export const WhyLove = ({ w }) => (
  <section className="pd-feature" data-testid="why-love-block">
    <Orn>Felindra</Orn>
    <h2 className="font-head">{w.title}</h2><p className="pd-feature-intro">{w.intro}</p>
    <ul>{w.points.map((pt, k) => <li key={k} data-testid={`why-love-point-${k}`}><span className="pd-num">{String(k + 1).padStart(2, "0")}</span><div><p className="pd-pt">{pt.title}</p><p>{pt.text}</p></div></li>)}</ul>
  </section>
);

export const CareBlock = ({ c }) => (
  <section className="pd-care" data-testid="care-block">
    <div><Gem size={22} strokeWidth={1.2} /><h2 className="font-head">{c.title}</h2><Link to={c.link} data-testid="care-guide-link">Lire le guide d'entretien complet</Link></div>
    <ul>{c.tips.map((x, k) => <li key={k}>{x}</li>)}</ul>
  </section>
);
